import React from "react";

const NotFound = () => {
  return (
    <div className="cursor-pointer text-6xl font-bold">Page Not Found</div>
  );
};

export default NotFound;
